import {SlimPanel} from "./SlimPanel";
import '/modules/common/css/coordinates-panel.css';
import '/modules/common/css/coordinates-panel.mobile.css';
import {Overlay} from "ol";
import {transform} from "ol/proj";
import {WGS84_CODE} from "../config/config";

/**
 * A slim panel to point to coordinates on the map
 * @extends SlimPanel
 */
class CoordinatesPanel extends SlimPanel {

    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Panel id
     * @param classes {string} HTML classes for the panel
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(translator, isMobileDevice, id, classes, runtimeConfig, onChangeRuntimeConfig) {
        super(translator, isMobileDevice, id, classes, runtimeConfig, onChangeRuntimeConfig);
        this.hideCallbacks = [];
    }

    getClassName(){
        return "CoordinatesPanel";
    }

    getUIElement() {
        return super.getUIElement().show().addClass('coordinates-panel');
    }

    /**
     * Add a callback to call when the panel is hidden
     * @param callback {function}
     */
    onHide(callback) {
        this.hideCallbacks.push(callback);
    }

    hide() {
        if(this.isVisible()) {
            super.hide();
            this._afterHide();
        }
    }

    hideNoAnimation() {
        if(this.isVisible()) {
            super.hideNoAnimation();
            this._afterHide();
        }
    }

    _afterHide() {
        this.getOverlay().setPosition(undefined);
        for (let c in this.hideCallbacks)
            this.hideCallbacks[c]();
    }

    /**
     * Get the OpenLayers Overlay of this panel
     * @return {Overlay}
     */
    getOverlay() {
        if (!this.overlay) {
            this.overlay = new Overlay({
                element: this.getUIElement()[0],
                autoPan: true,
                autoPanAnimation: {
                    duration: 250
                }
            });
        }
        return this.overlay;
    }

    /**
     * Show this panel on the given coordinates
     * @param wgs84Coordinates {Array<number>} The coordinates where to show the panel in WGS84
     */
    showOnGeoCoords(wgs84Coordinates) {
        this.showNoPosition();
        this.coords = wgs84Coordinates;
        this.getOverlay().setPosition(transform(this.coords, WGS84_CODE, this.getOverlay().getMap().getView().getProjection().getCode()));
    }

    /**
     * Set the current map projection
     * @param projection {Projection}
     */
    setProjection(projection) {
        if (this.isVisible()) {
            this.showOnGeoCoords(this.coords);
        }
    }
}

export {CoordinatesPanel}